<template>
  <section>
    <LayoutAccount>
        <template #title>
            {{ $t('pages.login.headline_title_line1') }} {{ $t('pages.login.headline_title_line2') }}
        </template>
        <template #subtitle>
          <span>{{$t('pages.login.headline_txt')}}<router-link :to="{ name: 'signup' }" exact class="p-2 text-primary">{{$t('forms.login_form.create_account_btn')}}
        </router-link></span>
        </template>

        <template #mainContent>
            <LoginForm/>
        </template>
    </LayoutAccount>
    <template v-if="isPicaThirdLevelDomain">
      <B2BSection/>
    </template>
  </section>
</template>


<script>
import LayoutAccount from "@/components/LayoutAccount"
import LoginForm from '@/components/LoginForm'
import B2BSection from "@/components/B2BSection.vue";
import {mapGetters} from "vuex";

export default {
    components: {
      B2BSection,
        LayoutAccount,
        LoginForm
    },
      computed: {
    ...mapGetters(['isPicaThirdLevelDomain']),
  },
}
</script>
